import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CorePipesModule } from '@sla-ng/core';
import { ProductionVersionPage } from './production-version.page';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export * from './production-version.page';

const routes: Routes = [
    {
        path: '',
        component: ProductionVersionPage,
    },
];

@NgModule({
    declarations: [ ProductionVersionPage ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatCheckboxModule,
        ReactiveFormsModule,
        MatProgressBarModule,
        MatSortModule,
        MatTableModule,
        CorePipesModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule,
    ],
    providers: [
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    ],
})
export class ProductionVersionPageModule {
}
